export const ThresholdDot = ({ 
	isChecked = false,
	children
}: { 
	isChecked?: boolean;
	children?: React.ReactNode;
}) => {
	return (
		<div 
			className="shop-coin-progress__item" 
			data-check={isChecked}
		>
			<span className="shop-coin-progress__value"></span>
			
			{!isChecked ? children : null}
		</div>
	);
};